import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import CommonModal from 'PhishingManager/components/Modal';

const SaveChangesModal = ({
	onClose,
	isProfile,
	isAddNewUser
}: {
	isProfile: boolean;
	isAddNewUser: boolean;
	onClose: () => void;
}) => {
	const { t } = useTranslation();
	const { isSubmitting, submitForm } = useFormikContext();

	return (
		<CommonModal
			visible
			modalTitle={t(
				isProfile || isAddNewUser
					? `saveChanges`
					: 'profile.editChangeTitle'
			)}
			confirmText={t('saveChanges')}
			cancelText={t('cancel')}
			iconType={null}
			confirmBtnDisabled={isSubmitting}
			showConfirmBtn={true}
			onClose={onClose}
			onConfirm={submitForm}
			modalContentDesc={[
				t(
					isProfile
						? `profile.saveChangeDesc`
						: isAddNewUser
						? 'profile.newUserSaveDesc'
						: 'profile.editChangeDesc'
				)
			]}
		/>
	);
};

export default SaveChangesModal;
